// export const base_url = "https://sheheryaralamkhan.com/projects/supergallery_dev/supergallery/module/";
// export const BASE_PATH = "/projects/supergallery_dev";
// Basis-URL van de PrestaShop module-API's; instelbaar via REACT_APP_API_BASE (bijv. in .env).
export const base_url = process.env.REACT_APP_API_BASE || "https://www.supergallery.nl/supergallery/module/";
export const BASE_PATH = "";
